import {Injectable} from '@angular/core';
import {CanDeactivate} from '@angular/router';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {PwaModeService} from './pwa-mode.service';
import {UserService} from './user.service';
import {CreateNewSlistComponent} from '../content-page/common/suggestion-lists/components/create-new-slist/create-new-slist.component';
import {ConfirmationPopupComponent} from '../content-page/views/view-group/popups/confirmation-popup/confirmation-popup.component';

const CONFIRMED_RESULT = 'ok';
const UNSAVED_MESSAGE = 'Unsaved data will be lost. Continue?';
const NO_PHOTOS = 0;

@Injectable()
export class PwaSuggestionLeaveGuard implements CanDeactivate<CreateNewSlistComponent> {
  constructor(private mode: PwaModeService, private modal: NgbModal, private users: UserService) {}

  canDeactivate(component: CreateNewSlistComponent): boolean | Promise<boolean> {
    if (!this.mode.isEnabled) { return true; }
    if (!this.users.getLocal()) { return this.allowDeparture(component); }
    if (component.allBtnsIsDisabled) { return false; }
    const hasPhotos = component.suggestionListsService.photosService.length > NO_PHOTOS;
    if (component.navigationConfirmed || (component.canLeavePage() && !hasPhotos)) {
      return this.allowDeparture(component);
    }
    const confirmation = this.modal.open(ConfirmationPopupComponent);
    confirmation.componentInstance.massage = UNSAVED_MESSAGE;
    return confirmation.result.then(
      result => result === CONFIRMED_RESULT && this.allowDeparture(component),
      () => false
    );
  }

  private allowDeparture(component: CreateNewSlistComponent): boolean {
    component.skipAutomaticDraftSave = true;
    return true;
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/services/pwa-suggestion-leave.guard.ts